export function isArrayDefined<T>(arr?: Array<T>): arr is Array<T> {
  return !!arr && arr.length > 0;
}
